import { render } from "./accountHeader.vue?vue&type=template&id=6ece617c&scoped=true"
import script from "./accountHeader.vue?vue&type=script&lang=js"
export * from "./accountHeader.vue?vue&type=script&lang=js"

import "./accountHeader.vue?vue&type=style&index=0&id=6ece617c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ece617c"

export default script